import styled from 'styled-components';

/** Figma: top-right mButtonIcon has no scrim/fill on this card (design-system scope only). */
export const Root = styled.div`
  [data-testid='web-ui-kit-OCardLayeredStandard-button-icon'] button {
    background-color: transparent;
    backdrop-filter: none;

    &:hover:not(:disabled),
    &:focus:not(:disabled) {
      background-color: transparent;
    }
  }
`;
